import React from 'react';
import { useTalent } from "../../providers/TalentProvider";
import InfoTooltip from "../../components/InfoTooltip";
import { useAuth } from '../../providers/AuthProvider';
import HideTalentPricingTooltip from '../clients/HideTalentPricingTooltip';

const TalentTileRate = ({ onUpdate, overrideProps = {}, ...props }) => {
    const {
        talent,
        // isDisabled,
        // overrideClientPreferredRate,
    } = useTalent();
    const { auth } = useAuth();

    return (
        <div className={TB.mapClass("candidate-rate-section relative", {
            "preferred-candidate-rate": talent.client_override_hourly_rate
        })}>
            <div id={`talent-rate-type-${talent.id}`} className="select-none">
                <h4>
                    {talent.client_override_hourly_rate ? "Preferred Rate" : "Standard Rate"}
                </h4>
                {auth.canViewTalentPricing() ? (
                    <h2 className="currency-sup">
                        {talent.rangedPlatformRates()}
                        <span>/hr</span>
                    </h2>
                ) : (
                    <h2>
                        <HideTalentPricingTooltip />
                    </h2>
                )}
            </div>
            {talent.client_override_hourly_rate && (
                <InfoTooltip target={`talent-rate-type-${talent.id}`} type="dark" placement="top">
                    <p className="text-xs text-white italic py-1 px-2" style={{ textTransform: 'none' }}>
                        This talent offers a preferred rate for your organization
                    </p>
                </InfoTooltip>
            )}
        </div>
    )
};

export default TalentTileRate;